var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ad6fbe5e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "component-socket-value__icon"
};
const _hoisted_2 = {
    key: 1,
    class: "socket-controls"
};
import { computed, toValue } from "vue";
import { useBuiltComponent } from "src/shared/store/component-built/composables";
import ComponentDisplayName from "src/shared/v-components/component/ComponentDisplayName.vue";
import { useComponentMutableKeyForEditing } from "src/shared/store/component-mutable/composables/useComponentMutableKey";
import { useComponentVariableMutable } from "src/shared/store/component-mutable/composables/useComponentVariableMutable";
import { saveComponentVariable } from "src/shared/store/component/service/saveComponent";
import { ref } from "vue";
import notificationService from "src/shared/notification/notification-service";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EnableableComponentSocketValue',
    props: {
        componentId: {},
        size: { default: "medium" },
        settingName: {}
    },
    emits: ["navigateToViewComponent", "confirmDeleteInstalledComponent"],
    setup(__props, { emit: __emit }) {
        _useCssVars(_ctx => ({
            "6cdbbaba": (componentSocketValueBorderColor.value)
        }));
        const props = __props;
        const emit = __emit;
        const { componentMutableKey } = useComponentMutableKeyForEditing(() => props.componentId);
        const { componentVariableMutable } = useComponentVariableMutable(componentMutableKey, "enabled");
        const isLoading = ref(false);
        const isEnabled = computed({
            get() {
                const componentVariableMutableValue = toValue(componentVariableMutable);
                if (!componentVariableMutableValue) {
                    return false;
                }
                const defaultValue = componentVariableMutableValue.getValue("default");
                return Boolean(defaultValue);
            },
            set: (newValue) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                const componentVariableMutableValue = toValue(componentVariableMutable);
                if (!componentVariableMutableValue) {
                    return;
                }
                try {
                    isLoading.value = true;
                    componentVariableMutableValue.setValue("default", newValue);
                    yield saveComponentVariable(componentVariableMutableValue);
                    notificationService.success(`${(_a = builtComponent.value) === null || _a === void 0 ? void 0 : _a.getDisplayName()} has been ${newValue ? "enabled" : "disabled"}`);
                }
                catch (e) {
                    console.error(e);
                    (_b = componentVariableMutable.value) === null || _b === void 0 ? void 0 : _b.pull();
                }
                finally {
                    isLoading.value = false;
                }
            }),
        });
        const { builtComponent: builtComponentRef } = useBuiltComponent(props.componentId);
        const builtComponent = computed(() => builtComponentRef.value);
        const componentSocketValueBorderColor = computed(() => {
            var _a;
            return ((_a = builtComponent.value) === null || _a === void 0 ? void 0 : _a.getColor()) || "#969dab";
        });
        const componentSocketValueIcon = computed(() => {
            var _a;
            return ((_a = builtComponent.value) === null || _a === void 0 ? void 0 : _a.getIcon()) || undefined;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["component-socket-value", {
                        'component-socket-value--small': _ctx.size === 'small',
                        'component-socket-value--medium': _ctx.size === 'medium',
                        'component-socket-value--loading': isLoading.value,
                        'component-socket-value--disabled': !isEnabled.value,
                    }]),
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (emit('navigateToViewComponent', _ctx.componentId)), ["stop"]))
            }, [
                (componentSocketValueIcon.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("i", {
                            class: _normalizeClass(componentSocketValueIcon.value)
                        }, null, 2 /* CLASS */)
                    ]))
                    : _createCommentVNode("v-if", true),
                _createVNode(ComponentDisplayName, {
                    "tag-name": 'h3',
                    componentId: _ctx.componentId
                }, null, 8 /* PROPS */, ["componentId"]),
                (_ctx.size === 'medium')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("i", {
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (emit('confirmDeleteInstalledComponent')), ["stop"])),
                            class: "fal fa-trash"
                        })
                    ]))
                    : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */));
        };
    }
});
